<div class="vc-modal__innerContainer vc-modal__innerContainer--full authentication__container">
  <button aria-label="close modal" class="vc-modal__closeBtn d-none d-md-block" [mat-dialog-close]>
    <span class="vc-modal__closeBtn__crossLeft"></span> <span class="vc-modal__closeBtn__crossRight"></span>
  </button>
  <div class="authentication__row row no-gutters">
    <div class="col-xs-12 col-md-6 d-none d-md-flex">
      <div class="authentication__actionVisual">
        <div class="authentication__actionImage">
          <img class="authentication__actionImage__logo" src="/assets/img/home/vestiairecollective_logo.svg?v=1" />
        </div>
        <div class="authentication__actionContent">
          <div class="authentication__actionContent__title" i18n="@@LOGIN_MODAL.TEXT.YOU_WANT_IN">
            You want in ?
          </div>
          <div class="authentication__actionContent__text">
            <div class="authentication__actionContent__text__list">
              <vc-sprite-icons name="check-in-case" class="authentication__actionContent__text__list__checkbox">
              </vc-sprite-icons>
              <label
                for="deals"
                class="authentication__actionContent__text__list__label"
                i18n="@@LOGIN_MODAL.TEXT.FIND_DEALS"
              >
                Find Deals</label
              >
            </div>
            <div class="authentication__actionContent__text__list">
              <vc-sprite-icons name="check-in-case" class="authentication__actionContent__text__list__checkbox">
              </vc-sprite-icons>
              <label
                for="offers"
                class="authentication__actionContent__text__list__label"
                i18n="@@LOGIN_MODAL.TEXT.MAKE_OFFERS"
                >Make Offers</label
              >
            </div>
            <div class="authentication__actionContent__text__list">
              <vc-sprite-icons name="check-in-case" class="authentication__actionContent__text__list__checkbox">
              </vc-sprite-icons>
              <label
                for="buysell"
                class="authentication__actionContent__text__list__label"
                i18n="@@LOGIN_MODAL.TEXT.BUY_SELL_BETTER"
                >Buy and Sell Better</label
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xs-12 col-md-6">
      <div class="authentication__actionContainer">
        <ng-container *ngIf="type === 'register'">
          <div class="authentication__registerContainer" *ngIf="!resetPassword">
            <vc-register [popinForced]="popinForced"></vc-register>
            <button
              class="authentication__toggleLoginSubscribe"
              (click)="displayComponent('login')"
              i18n="@@REGISTER_MODAL.BTN_TOWARD_LOGIN"
            >
              Log in
            </button>
          </div>
        </ng-container>
        <ng-container *ngIf="type === 'login'">
          <div class="authentication__loginContainer" *ngIf="!resetPassword">
            <vc-login
              (displayResetPassword)="displayResetPassword($event)"
              (currentEmail)="setCurrentEmail($event)"
              [popinForced]="popinForced"
            ></vc-login>
            <button
              class="authentication__toggleLoginSubscribe"
              (click)="displayComponent('register')"
              i18n="@@LOGIN_MODAL.BTN_TOWARD_REGISTER"
            >
              Sign up
            </button>
          </div>
          <div *ngIf="resetPassword" class="authentication__passwordResetContainer">
            <vc-password-reset
              [currentEmail]="email"
              [popinForced]="popinForced"
              (displayResetPassword)="displayResetPassword($event)"
              class="authentication__passwordReset"
            >
            </vc-password-reset>
          </div>
        </ng-container>
        <ng-container *ngIf="type === 'login-register'">
          <div class="authentication__loginContainer">
            <vc-login-register-screen (switchModal)="displayComponent($event)" [popinForced]="popinForced">
            </vc-login-register-screen>
          </div>
        </ng-container>
        <div class="authentication__actionContainer__recommendedBy">
          <div class="recommendedBy__txt" i18n="@@LOGIN_MODAL.RECOMMENDED_BY">Recommended by</div>
          <img class="vc-icon" src="/assets/svg/logo-vogue.svg" alt="" />
          <img class="vc-icon" src="/assets/svg/logo-glamour.svg" alt="" />
          <img class="vc-icon" src="/assets/svg/logo-gq.svg" alt="" />
          <img class="vc-icon" src="/assets/svg/logo-vanityfair.svg" alt="" />
          <img class="vc-icon" src="/assets/svg/logo-ad.svg" alt="" />
        </div>
        <div class="authentication__actionContainer__rgpd" *ngIf="type === 'register'">
          <vc-popover #rgpdPopover placement="top" [closeOnClickOutside]="true">
            <ng-container i18n="@@LOGIN_MODAL.RGPD.RGPD_TEXT">
              We hereby inform you that the personal data you provide in this form is collected and processed by
              Vestiaire Collective for the purpose of managing your user accounts, your complaints (if any), the
              services you subscribe and the products you purchase or sell, for sending you our newsletters and
              advertisements and for carrying out surveys and statistics. In accordance with applicable regulations, you
              have the right to access, block, modify and delete your personal data and the right to give instructions
              concerning the use of your personal data after your lifetime. You also have a right to data portability
              and a right to restrict the processing of your data in certain specific cases stipulated in EU Regulation
              No 2016/679 of 27 April 2016. To exercise your rights, please contact dataprivacy@vestiairecollective.com
            </ng-container>
          </vc-popover>
          <a
            class="authentication__actionContainer__rgpd__link"
            [appPopover]="rgpdPopover"
            [class.open]="popoverDirective?.visible"
          >
            <ng-container *ngIf="!popoverDirective?.visible" i18n="@@LOGIN_MODAL.RGPD.RGPD_LINK_SHOW_TEXT"
              >Learn more about my data</ng-container
            >
            <ng-container *ngIf="popoverDirective?.visible" i18n="@@LOGIN_MODAL.RGPD.RGPD_LINK_HIDE_TEXT"
              >Close
            </ng-container>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
